<template>
  <div class="d-flex flex-column align-items-center justify-content-center min-vh-100 p-5">
    <div class="text-center">
      <img src="@/assets/images/logo_ubbi.png" alt="Ubbimed" class="h-50px mb-5">
      <h4 class="mb-2">Acessando conta do usuário</h4>
      <p class="text-muted mb-0">Aguarde enquanto preparamos a sessão...</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImpersonateLogin',
  async created() {
    const rawToken = this.$route.query.token;
    const token = Array.isArray(rawToken) ? rawToken[0] : rawToken;

    if (!token) {
      await this.showError('Link de impersonação inválido.');
      return;
    }

    try {
      await this.$store.dispatch('auth/bootstrapFromToken', token);

      if (this.$store.state.auth.place) {
        await this.$router.replace('/dashboard');
        return;
      }

      // Usuário com múltiplos locais: loadPlaces redireciona via window.location.
      if (window.location.pathname === '/auth/impersonate') {
        await this.$router.replace('/places');
      }
    } catch {
      await this.showError('Não foi possível iniciar a sessão de suporte.');
    }
  },
  methods: {
    async showError(message) {
      await Swal.fire({
        title: 'Opsss!',
        text: message,
        icon: 'error',
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      });

      this.$router.replace('/login');
    },
  },
};
</script>
